import { startTransition, useCallback, useEffect, useMemo, useState, useRef, cloneElement } from "react";
import * as API from "../../../framework/API/api";
import { Splitter } from "@progress/kendo-react-layout";
import Planning_prformance from "./Planning_performance";
import PlanningMediaLibraryCollection from "../PlanningMediaLibraryCollection";
import { ENTITYNAME, FILEURL, LOCALSTORAGE_KEY, PLANNINGTYPE, EXPORT_TYPE, OFFSET, MODULE, PLANNING_DELETE_OPTION, MEDIACATEGORIES, SOCKET_EVENTS, SOCKET_ACTION, MILLISECONDSINADAY, SCHEDULETYPE, PLANNING_VIEW, ApplicationConfigurationKeys, MODULETYPES, PUBLISH_REPORT, PUBLISH_REPORT_CONFIG, getPublishReportConfig, TOAST_TYPES } from "../../../framework/constant/constant";
import { useTranslation } from "../../../locale/useTranslation";
import { Checkbox, Input } from "@progress/kendo-react-inputs";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { utility } from "../../../framework/utility/utilityProvider";
import moment from "moment";
import { PlanningHelper } from "../helper/PlanningHelper";
import PlaningFooter from "./PlanningFooter";
import { PlanningPreference } from "../planningPreference/PlanningPreference";
import { Recursive } from "../Recursive";
import MediaEpisodeHistory from "../MediaEpisodeHistory";
import CollectionSelection from "../../../framework/forms/CollectionSelection";
import ActionButton from "../../../framework/forms/helpercomponents/buttons/ActionButton";
import { CopySchedule } from "../CopySchedule";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import PlanningDistribution from "../PlanningDistribution";
import TabContext from "@mui/lab/TabContext/TabContext";
import { Box, Button, Tab, Typography } from "@mui/material";
import TabList from "@mui/lab/TabList/TabList";
import TabPanel from "@mui/lab/TabPanel/TabPanel";
import PlanningVersionTab from "../PlanningVersionTab";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { DateOnlyCell } from "../../../framework/forms/helpercomponents/CustomGridCells/DateCell";
import { TimeCell } from "../../../framework/forms/helpercomponents/CustomGridCells/TimeCell";
import ProgressBarPopup from '../../../framework/forms/helpercomponents/ProgressBarPopup';
import InfoRoundButton from "../../../components/InfoRoundButton";
import { EditPageHeader } from "../../../components/EditPageHeader";
import { TimePickerWithFormat } from "../../../framework/forms/helpercomponents/timepicker/TimePickerWithFormat";
import socket from "../../../framework/socket/socket";
import PlanningLiveEventsTab from "../PlanningLiveEventsTab";
import PlanningSeriesTab from "../PlanningSeriesTab";
import RoundButton from "../../../framework/forms/helpercomponents/buttons/RoundButton";
import { Loader } from "../../../framework/forms/helpercomponents/Loader";
import { ProgressBar } from "@progress/kendo-react-progressbars";
import { ArrayCell } from "../../../framework/forms/helpercomponents/CustomGridCells/ArrayCell";
import BossDialog from "../../../components/BossDialog";
import MediaDealRightsPopup from "../MediaDealRightsPopup";
import { contractMediaEpisodeColumns } from "../../../framework/utility/customColumns";
import PlanningContractMediaLibraryCollection from "../PlanningContractMediaLibraryCollection";
import SeriesTimeLineView from "../../TimelineView/SeriesTimeLineView";
import bossAIPng from '../../../img/BOSS-AI.png';
import MissingSegmentMamReport from "../report/MissingSegmentMamReport";
import PlanningInsertDummyPopup from "../PlanningInsertDummyPopup";
import { CopySlotsForm } from "../../masters/CopySlotsForm";
import PlannerExportExcelForm from "../PlannerExportExcelForm";
import PlanningFilterDialog from "./PlanningFilterDialog";
import RecursivePlanPopup from "../RecursivePlanPopup";
import ToastNotification from "../../../components/ToastNotification";

const PlannerWrapperNew = (props) => {

  const { isPrimeTime } = props;

  const lang = useTranslation();
  const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);
  const enableBossAI = utility.getApplicationConfigurationByKey(ApplicationConfigurationKeys.EnableBossAI) ?? false;
  const disableLiveEventSection = company && company?.disableLiveEventSection != undefined && company?.disableLiveEventSection;
  var publishData = utility.getSeassionValue(LOCALSTORAGE_KEY.planningPublishData);
  const [showFilter, setShowFilter] = useState(publishData === null);
  const [ChannelList, setChannelList] = useState(
    publishData ? publishData.channels : []
  );
  const [planningChannelSelectorFilteredChannels, setPlanningChannelSelectorFilteredChannels] = useState(publishData ? publishData.channels.map((x) => {
    return {
      ...x,
      name: x.FullChannelName,
    }
  }) : []);
  const [filterChannels, _setFilterChannels] = useState(
    publishData ? publishData.channels.map((x) => {
      return {
        ...x,
        name: x.FullChannelName,
      }
    }) : []
  );
  const filterChannelRef = useRef(filterChannels);
  const setFilterChannels = (data) => {
    filterChannelRef.current = data;
    _setFilterChannels(data);
    setPlanningChannelSelectorFilteredChannels(data);
  }
  const [isFirst, setIsFirst] = useState(publishData ? false : true);
  const [date, setDate] = useState(
    publishData ? new Date(publishData.planningdate) : new Date()
  );
  const [selectedDate, setSelectedDate] = useState(
    publishData ? new Date(publishData.planningdate) : new Date()
  );

  const [statusMsg, setStatusMsg] = useState("");

  const [showProgressBar, setShowProgressBar] = useState({ okButton: false, progressBarPopup: false });
  const [progressData, setProgressData] = useState({ message: '', progress: 0 });

  const [panes, setPanes] = useState([
    {
    },
    {
      size: "30%",
      collapsible: true,
    },
  ]);
  const planningRef = useRef();
  const liveEventRef = useRef();
  const plannerSelectedItemsRef = useRef([]);
  const [plannerCopiedItems, setPlannerCopiedItems] = useState([]);
  const [openPlanningPreference, setOpenPlanningPreference] = useState();
  const [showRecursivePopup, setShowRecursivePopup] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [showInsertProgramGroup, setShowInsertProgramGroup] = useState(false);
  const [showExhibitions, setShowExhibitions] = useState(false);
  const [programScheduleExhibitionData, setProgramScheduleExhibitionData] = useState([]);
  const [exhibitionStatus, setExhibitionStatus] = useState('Loading');

  const [doLoad, setDoLoad] = useState(false);
  const [planningGroupItems, setPlanningGroupItems] = useState([]);
  const [showExportExcelPopup, setShowExportExcelPopup] = useState(false);
  const [showCopySchedulePopup, setShowCopySchedulePopup] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [exportChannel, setExportChannel] = useState({});
  const [durationType, setDurationType] = useState("Nominal");
  const [startType, setStartType] = useState("Nominal");
  const [showPlanningDistributionTemplate, setShowPlanningDistributionTemplate] = useState(false);
  const [tabValue, setTabValue] = useState('1');
  const [showCtrlAPopup, setShowCtrlAPopup] = useState(false);
  const [selectedCtrlAOption, setSelectedCtrlAOption] = useState(-1);
  const [selectedDeleteOption, setSelectedDeleteOption] = useState(0);
  const [showLoopPopup, setShowLoopPopup] = useState(false);
  const [showAutoPlanningPopup, setShowAutoPlanningPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showAutoPlanningTentativePopup, setShowAutoPlanningTentativePopup] = useState(false);
  const [autoPlanningTentativeData, setAutoPlanningTentativeData] = useState({});
  const [autoPlaningData, setAutoPlaningData] = useState({
    Channel: {},
    FromDate: "",
    ToDate: "",
  });

  const [showCheckList, setShowCheckList] = useState(false);
  const [payload, setPayload] = useState({});
  const [loopPopupData, setLoopPopupData] = useState({
    channels: [],
    startDate: new Date(),
    startDateTime: "00:00:00:00",
    endDate: new Date(),
    endDateTime: "00:00:00:00",
    duration: 0,
    data: {}
  });


  const [showDealPopup, setShowDealPopup] = useState({ show: false, mediaDealRight_id: null });
  const [currentPlanningView, setCurrentPlanningView] = useState(PLANNING_VIEW.PLANNER_VIEW);
  const [showExportMissingSegmentMAMReportPopup, setShowExportMissingSegmentMAMReportPopup] = useState(false);
  const [showDummyPlanningPopup, setShowDummyPlanningPopup] = useState(false);
  const [showCopySlotPopup, setShowCopySlotPopup] = useState(false);
  const [showRecursivePlanPopup, setShowRecursivePlanPopup] = useState(false);
  const isFilterLoadingRef = useRef(false);


  //for loading channel list
  useEffect(() => {
    loadChannelsList();
  }, []);



  const loadChannelsList = async () => {
    let response = await API.getValidChannels();

    if (response.success) {
      setChannelList(
        response.data.map((d) => ({
          ...d,
          name: d.FullChannelName,
          SID: d.SID,
          Color: d.Color,
        }))
      );

      //setting first channel in filter list by default
      console.log(publishData)
      if (publishData?.channels.length === 0) {
        setFilterChannels([{
          ...response.data[0],
          name: response.data[0].FullChannelName,
          SID: response.data[0].SID,
          Color: response.data[0].Color,
        }])
      }

    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.error_fetching_channel_list_planning_wrapper_error_message });
    }
  };
  const onChange = useCallback((event) => {
    setPanes(event.newState);
  }, []);

  const planningLoading = useCallback(() => {
    setDoLoad((old) => old ? false : true);
  }, []);



  const handleChannelFilterDialog = useCallback(() => {
    setShowFilter((current) => !current);
  }, []);


  const handleFilterPopupConfirm = (showLoading) => {
    showLoading(true);
    const channels = planningChannelSelectorFilteredChannels;

    if (channels.length === 0) {
      ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: lang.please_select_channel_first });
      showLoading(false);
      return;
    }

    if (channels.length > 1) {
      const unqTZns = new Set(
        channels.map((x) => x?.TimeZone?.Code)
      );

      if (unqTZns.size > 1) {
        ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: `Cannot select multiple channels with different timezones` });
        showLoading(false);
        return;
      }
    }

    const planningDate = new Date(moment(date));

    isFilterLoadingRef.current = true;

    requestAnimationFrame(() => {
      startTransition(() => {
        setFilterChannels(channels);
        setSelectedDate(planningDate);
        setIsFirst(false);

        PlanningHelper.setPlanningPublishDataInLocalStorage({
          planningdate: planningDate,
          channels,
        });

        setExportChannel(channels[0]);
      });
    });
  };

  //changes date in scheduler
  const handleChangeDate = (event) => {
    setDate(event.value);
  };

  //changes date in scheduler
  const onDateChange = useCallback((dateFromPlanner) => {
    let finalDate = new Date(dateFromPlanner.getTime());
    setSelectedDate(finalDate);
    setDate(finalDate);
    var data = {
      planningdate: finalDate,
      channels: filterChannels,
    };
    PlanningHelper.setPlanningPublishDataInLocalStorage(data);

  },
    [filterChannels]
  );

  const setStatus = useCallback((msg) => {
    setStatusMsg(msg);
    if (isFilterLoadingRef.current) {
      isFilterLoadingRef.current = false;
      setShowFilter(false);
    }
  }, [])


  const onSelectedPlanningItem = useCallback((data) => {
    plannerSelectedItemsRef.current = data;
    const selectedCountElement = document.getElementById("planning-selected-count");
    if (selectedCountElement) {
      selectedCountElement.textContent = `${data.length} ${lang.selected_label}`;
    }
  }, [lang.selected_label])

  const onSetPlannerCopiedItems = useCallback((data) => {

    setPlannerCopiedItems(data);

  }, [])

  const onClickPlanningPreference = useCallback(() => {
    setOpenPlanningPreference(false);
  }, [])

  const updatePlanningPreferenceStyle = useCallback(() => {



    setOpenPlanningPreference(false);
    planningLoading();

  }, []);

  const onOpenPlanningPreference = useCallback(() => {
    setOpenPlanningPreference(true);
  }, [])

  const onSelectApplyRecursive = useCallback(() => {

    console.log(plannerSelectedItemsRef.current);

    if (plannerSelectedItemsRef.current.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_planning_item_planning_wrapper_error_message });
      return;
    }

    setShowRecursivePopup(true);
  }, [])


  const onSelectDistributePlanningAcrossChannels = useCallback(async () => {

    console.log("apply distribute");

    if (plannerSelectedItemsRef.current.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_planning_item_planning_wrapper_error_message });
      return;
    }

    setShowPlanningDistributionTemplate(true);

  }, [])

  const setDistributionTemplateData = async (distributionTemplate) => {

    setStatusMsg(`${lang.applying_planning_distribution_template_please_wait_planner_status_message}`)

    for (let index = 0; index < plannerSelectedItemsRef.current.length; index++) {

      const plannedItem = plannerSelectedItemsRef.current[index];

      await API.distributePlanningAcrossChannels(plannedItem, distributionTemplate);

    }

    planningLoading(); // refreshing for now then we will add episodes from response
    setStatusMsg(`${lang.planning_distribution_template_applied_success_planner_status_message}`)

  }


  const onGenerateRecursion = useCallback(async (dataItem) => {

    var startDate = utility.getLocalDateTimeToUtcMiliseconds(new Date(dataItem.FromDate));
    var endDate = utility.getLocalDateTimeToUtcMiliseconds(new Date(dataItem.ToDate))

    const lockedData = await API.getData(ENTITYNAME.PLAYLIST_LOCK_STATUS, { query: [['date', '>=', startDate], ['date', '<=', endDate], ['channel._id', '=', plannerSelectedItemsRef.current[0]?.Channel?._id]] });

    if (lockedData.data.length > 0) {
      setStatusMsg(`${lang.planning_is_locked_on_some_days_in_this_date_range}`);
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.planning_is_locked_on_some_days_in_this_date_range });
      return
    }

    setShowRecursivePopup(false);

    setStatusMsg(`${lang.applying_recursive_pattern_please_wait_planner_error_message}`)
    var response = await API.applyRecursion(plannerSelectedItemsRef.current[0], dataItem);


    if (response.success) {
      setStatusMsg(`${lang.recursive_applied_successfully_planning_wrapper_message}`)

      if (response.slotChanged) {
        ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: "Selected Item Slot Changed According to the Repeat Pattern Rules" });
      }

      socket()?.emit(SOCKET_EVENTS.onSocketData, { action: SOCKET_ACTION.PLANNING_REFRESH, module: MODULE.PLANNING, data: { scheduleScheduleStartDate: startDate, scheduleScheduleEndDate: endDate, channelSID: plannerSelectedItemsRef.current[0]?.Channel?.SID } });

      planningLoading(); // refreshing for now then we will add episodes from response

    }
    else {
      setStatusMsg(response.message);
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: response.message });
    }
  }, [])

  const closeFormHistory = () => {
    setShowHistory(false)
  }

  const onSelectShowHistory = useCallback(() => {

    if (plannerSelectedItemsRef.current.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_planning_item_planning_wrapper_error_message });
      return;
    }

    setShowHistory(true);

  }, [])

  const onSelectShowExhibition = useCallback(async () => {

    if (plannerSelectedItemsRef.current.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_planning_item_planning_wrapper_error_message });
      return;
    }

    setShowExhibitions(true);

    console.log(plannerSelectedItemsRef.current[0])

    //need to ask that we have to fetch data
    var res = await API.getData(ENTITYNAME.ProgramSchedule, {
      query: [
        ['MediaDealRight_id', '=', plannerSelectedItemsRef.current[0].MediaDealRight_id],
        ['MediaEpisode_id', '=', plannerSelectedItemsRef.current[0].MediaEpisode_id],
        ['PlanningType', '=', PLANNINGTYPE.Primary]
      ]
    });

    // console.log(res.data)
    if (res.data.length == 0) {
      setExhibitionStatus('No Record Found')
    }
    setProgramScheduleExhibitionData(res.data);

  }, [])

  const closeInsertProgramGroup = useCallback(() => {

    setShowInsertProgramGroup(false);

  }, [])


  const onInsertProgramGroup = useCallback(() => {

    setShowInsertProgramGroup(true);

  }, [])

  const addProgramGroup = useCallback((programGroups) => {

    if (programGroups.length > 0) {
      setPlanningGroupItems(programGroups[0]);
    }

  }, [])

  const showExcelPopup = useCallback(() => {

    setShowExportExcelPopup(true);

  }, [])

  const showMissingSegmentMAMReportPopup = useCallback(() => {

    setShowExportMissingSegmentMAMReportPopup(true);

  }, [])

  const closeLoopPopup = useCallback(() => {
    setShowLoopPopup(false);
  }, [])

  const onLoopConfirm = async () => {
    setShowLoopPopup(false);
    let startDate = new Date(new Date(loopPopupData.startDate).setUTCHours(0, 0, 0, 0, 0)).getTime() + utility.convertStringWithFramesToMilliseconds(loopPopupData.startDateTime);
    let endDate = new Date(new Date(loopPopupData.endDate).setUTCHours(0, 0, 0, 0, 0)).getTime() + utility.convertStringWithFramesToMilliseconds(loopPopupData.endDateTime);
    console.log(startDate, endDate)

    let res = await API.loopPlanning(startDate, endDate, loopPopupData.channels, loopPopupData.data);
    if (res.success) {
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "Loop Planned" });
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }
    setDoLoad(!doLoad);
  }

  const getAutoPlanningTentativeData = async () => {

    setIsLoading(true);

    let payload = {
      Channel: autoPlaningData?.Channel,
      FromDate: utility.convertStringDatetoMilliseconds(autoPlaningData?.FromDate),
      ToDate: utility.convertStringDatetoMilliseconds(autoPlaningData?.ToDate)
    }

    let res = await API.getAutoPlanningPlottingDataByPlanningSlots(payload);

    console.log(res)

    if (res.success) {
      setShowAutoPlanningPopup(false);
      setShowAutoPlanningTentativePopup(true);
      setAutoPlanningTentativeData(res.data);
      setTimeout(() => {
        setIsLoading(false);
        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "Tentative Planning Data" });
      }, 3000);
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }
    // setDoLoad(!doLoad);
  }

  const onAutoPlanningPlotting = async () => {

    //SEND DATA IN CHUNKS
    const CHUCKEDSIZE = 10;

    let onSaveResposnse = { success: false };

    setShowProgressBar({ okButton: true, progressBarPopup: true });


    let dataRowIndex = 0;
    while (dataRowIndex < autoPlanningTentativeData.length) {
      setProgressData({ message: 'Data uploading...', progress: Math.round(((dataRowIndex + 1) / autoPlanningTentativeData.length) * 100) });

      let chunckedData = [...autoPlanningTentativeData.slice(dataRowIndex, dataRowIndex + CHUCKEDSIZE)];
      console.log(chunckedData)
      onSaveResposnse = await API.savePlanningSlotSchedule(chunckedData);

      console.log(onSaveResposnse)

      if (!onSaveResposnse.success) break;

      dataRowIndex = dataRowIndex + CHUCKEDSIZE;
    }

    if (onSaveResposnse.success) {
      setProgressData({ message: 'Process completed', progress: 100 });
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: 'Process completed' });
      setShowAutoPlanningTentativePopup(false);
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "Auto Planning Plotted" });
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Something went wrong, Please try again !! " });
    }
    setDoLoad(!doLoad);
  }

  const onShowLoopPopup = useCallback((data) => {
    console.log(data)
    setLoopPopupData({
      channels: [data.Channel],
      startDate: new Date(data.SlotDateTime),
      startDateTime: utility.convertMilisecondsToStringWithFrames(data.SlotDateTime),
      endDate: new Date(data.SlotDateTime + data.mediaEpisode.Duration),
      endDateTime: utility.convertMilisecondsToStringWithFrames(data.SlotDateTime + data.mediaEpisode.Duration),
      duration: data.mediaEpisode.Duration,
      data: PlanningHelper.prepareDataforbackend(data)
    });

    setShowLoopPopup(true);

  }, [])

  const onShowAutoPlaningPopup = useCallback(() => {
    const currentPublishData = utility.getSeassionValue(LOCALSTORAGE_KEY.planningPublishData);

    setAutoPlaningData({
      Channel: currentPublishData.channels[0],
      FromDate: moment(currentPublishData.planningdate).utc().format('YYYY-MM-DD'),
      ToDate: moment(currentPublishData.planningdate).utc().add(7, 'd').format('YYYY-MM-DD'),
    });

    setShowAutoPlanningPopup(true);

  }, [])

  const onShowCopySchedulePopup = useCallback(() => {

    setShowCopySchedulePopup(true);

  }, [])

  const onShowCopySlotPopup = useCallback(() => {
    setShowCopySlotPopup(true);
  }, [])

  const onShowRecursivePlan = useCallback(() => {
    if (plannerSelectedItemsRef.current.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_planning_item_planning_wrapper_error_message });
      return
    }
    if (plannerSelectedItemsRef.current[0].RecursionParentProgramSchedule_id == null || plannerSelectedItemsRef.current[0].RecursionParentProgramSchedule_id.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Selected item is not a part of strand" });
      return
    }
    setShowRecursivePlanPopup(true);
  }, [])

  const onCloseCopySchedulePopup = useCallback(() => {

    setShowCopySchedulePopup(false);

  }, [])

  const onCloseCopySlotPopup = useCallback(() => {
    setShowCopySlotPopup(false);
  }, [])

  const onDurationTypeChange = useCallback((value) => {

    setDurationType(value)
  }, [])

  const onStartTypeChange = useCallback((value) => {

    utility.setValue(LOCALSTORAGE_KEY.planningpreference, {
      ...utility.getValue(LOCALSTORAGE_KEY.planningpreference),
      data: [{
        ...utility.getValue(LOCALSTORAGE_KEY.planningpreference).data[0],
        value: {
          ...utility.getValue(LOCALSTORAGE_KEY.planningpreference).data[0].value,
          StartType: value ?? "Nominal"
        }
      }]
    })

    setStartType(value)
  }, [])


  const MediaLibraryCollectionGridRowRender = useCallback((tr, props) => {
    const trProps = {
      draggable: true,
      onDragStart: (e) => {
        // to revert change width height back to normal as commented  zindex uncomment, id =drag-ghost and remove drag-ghost-del from ondrag end too
        // also go to planning performance.js and seee instructions there ln 816
        var elem = document.createElement("div");
        let duration = props.dataItem.Duration?.toString();
        elem.id = "drag-ghost-del";
        elem.textNode = "Dragging";
        elem.style.position = "fixed";
        elem.style.width = "0px";//150px
        elem.style.height = "0px";//200px
        elem.style.backgroundColor = "#3F497F";
        elem.style.whiteSpace = "pre-line";
        elem.textContent =
          props.dataItem.Title + "\r\n" + props.dataItem.AssetId;
        elem.style.opacity = 0;
        // elem.style.zIndex = 10000;
        // elem.style.transition = "0";//0.23
        elem.title = duration;
        document.body.appendChild(elem);
        e.dataTransfer.setDragImage(elem, 0, 0);
        var dataTransfer = {
          dataItem: props.dataItem,
          filterChannels: filterChannels,
        };
        e.dataTransfer.clearData();
        e.dataTransfer.setData("text/plain", JSON.stringify(dataTransfer));
      },
      onDragOver: (e) => { },
      onDragEnd: (e) => {
        var elem = document.getElementById("drag-ghost");
        var elem2 = document.getElementById("drag-ghost-del");
        if (elem) {
          document.body.removeChild(elem);
        }
        document.body.removeChild(elem2);
      },
    };
    return cloneElement(tr, { ...trProps }, tr.props.children);
  }, [filterChannels])

  const handleTabChange = useCallback((event, newValue) => {
    setTabValue(newValue);
  }, []);

  const onShowMedia = useCallback((mediaEpisode) => {
    let link = "/home/MediaEpisode/" + mediaEpisode?.MediaCategory?.Description + "/" + mediaEpisode?.SID;
    window.open(link, "_blank");
  }, [])

  const onShowDeal = useCallback((mediaEpisode) => {
    setShowDealPopup({ show: true, mediaDealRight_id: mediaEpisode?.MediaDealRight_id });
  }, [])

  const showCtrlADialog = useCallback(() => {
    setShowCtrlAPopup(true);
  }, [])

  const showDeleteMenu = useCallback(() => {
    if (showLoopPopup) {
      return;
    }
    setSelectedDeleteOption(0);
    setShowDeletePopup((current) => !current);
  }, [showLoopPopup])

  const onClickCtrlACancelAction = () => {
    setShowCtrlAPopup(false);
  }

  const onClickCtrlAOptions = (option) => {
    if (selectedCtrlAOption == option) {
      setSelectedCtrlAOption(-1);
      return;
    }
    setSelectedCtrlAOption(option);
  }

  const onClickDeleteOptions = (option) => {
    if (selectedDeleteOption == option) {
      return;
    }
    setSelectedDeleteOption(option);
  }

  const onClickCtrlAOkayAction = () => {
    if (selectedCtrlAOption == -1) {
      onClickCtrlACancelAction();
    } else {
      switch (selectedCtrlAOption) {
        case 0:
          planningRef.current.selectAllPlanningData();
          break;
        case 1:
          planningRef.current.selectAllPlanningDataForSelectedDate();
          break;
        case 2:
          planningRef.current.selectItemsOfSimilarEpisodes();
          break;
        case 3:
          planningRef.current.selectAllEpisodesOfSelectedSeries();
          break;
        default:
          break;
      }
      setShowCtrlAPopup(false);
    }
  }


  const onClickDeleteOkayAction = async () => {
    setShowDeletePopup(false);
    await planningRef.current.deletePlanningItemFromMenu(selectedDeleteOption);
    if (selectedDeleteOption != PLANNING_DELETE_OPTION.DELETE_SELECTED) setDoLoad(!doLoad);
  }

  const onCheckList = useCallback(() => {
    setShowCheckList((current) => !current);
  }, [])

  const refreshLiveEvent = useCallback(() => {
    if (liveEventRef.current) liveEventRef.current.onRefresh();
  }, [])

  const dummyPlanningPopup = useCallback(() => {
    setShowDummyPlanningPopup(true);
  }, []);

  const onScheduleRefreshWithSocket = useCallback(() => { }, []);

  const planningPane = useMemo(() => {
    if (currentPlanningView == PLANNING_VIEW.PLANNER_VIEW) {
      return (
        <Planning_prformance
          ref={planningRef}
          filterChannels={filterChannels}
          date={selectedDate}
          onDateChange={onDateChange}
          setStatus={setStatus}
          onSelectedPlanningItem={onSelectedPlanningItem}
          onSetPlannerCopiedItems={onSetPlannerCopiedItems}
          onSelectApplyRecursive={onSelectApplyRecursive}
          onSelectShowHistory={onSelectShowHistory}
          onInsertProgramGroup={onInsertProgramGroup}
          doLoad={doLoad}
          durationType={durationType}
          planningGroupItems={planningGroupItems}
          onSelectDistributePlanningAcrossChannels={onSelectDistributePlanningAcrossChannels}
          isPrimeTime={isPrimeTime}
          onShowMedia={onShowMedia}
          onShowDeal={onShowDeal}
          onShowExhibitions={onSelectShowExhibition}
          showCtrlADialog={showCtrlADialog}
          showDeleteMenu={showDeleteMenu}
          onShowLoopPopup={onShowLoopPopup}
          showCheckList={showCheckList}
          onCheckList={onCheckList}
          refreshLiveEvent={refreshLiveEvent}
          setPayload={setPayload}
          startType={startType}
          setStartType={setStartType}
          onShowCopySlotPopup={onShowCopySlotPopup}
          onShowCopySchedulePopup={onShowCopySchedulePopup}
          onShowRecursivePlan={onShowRecursivePlan}
          setStatusMsg={setStatusMsg}
        />
      );
    }

    if (currentPlanningView == PLANNING_VIEW.SERIES_TIMELINE_VIEW) {
      return (
        <SeriesTimeLineView
          showTitle={false}
          hideShow={true}
          selectedDate={selectedDate}
          onDateChange={onDateChange}
          filterChannels={filterChannels}
        />
      );
    }

    return null;
  }, [
    currentPlanningView,
    filterChannels,
    selectedDate,
    onDateChange,
    setStatus,
    onSelectedPlanningItem,
    onSetPlannerCopiedItems,
    onSelectApplyRecursive,
    onSelectShowHistory,
    onInsertProgramGroup,
    doLoad,
    durationType,
    planningGroupItems,
    onSelectDistributePlanningAcrossChannels,
    isPrimeTime,
    onShowMedia,
    onShowDeal,
    onSelectShowExhibition,
    showCtrlADialog,
    showDeleteMenu,
    onShowLoopPopup,
    showCheckList,
    onCheckList,
    refreshLiveEvent,
    startType,
    setStartType,
  ]);

  return (
    <>
      <Splitter panes={panes} onChange={onChange} style={{ height: "89%" }}>

        {planningPane}

        <TabContext value={tabValue}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleTabChange} aria-label="lab API tabs example" variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile>
              <Tab label={lang.media_library_dialog_header} value="1" />
              <Tab label={lang.series_library_label} value="2" />
              <Tab label={lang.version_label} value="3" />
              <Tab label={lang.history_label} value="4" />
              {!disableLiveEventSection && <Tab label={lang.live_events_label} value="5" />}
              <Tab label={lang.contract_media_library_label} value="6" />
            </TabList>
          </Box>
          <TabPanel value="1" style={{ height: "100%", padding: 0 }} >
            <PlanningMediaLibraryCollection
              title={lang.media_library_dialog_header}
              entityname={ENTITYNAME.MediaEpisode}
              channels={filterChannelRef.current}
              MediaLibraryCollectionGridRowRender={MediaLibraryCollectionGridRowRender}
              planningLoading={planningLoading}
              payload={payload}
            />
          </TabPanel>

          <TabPanel value="2" style={{ height: "100%", padding: 0 }} >
            <PlanningSeriesTab
              doLoad={doLoad}
              channels={filterChannels}
            />
          </TabPanel>
          <TabPanel value="3" style={{ height: "100%", padding: 0 }} >
            <PlanningVersionTab plannerSelectedItem={plannerSelectedItemsRef.current.length > 0 ? plannerSelectedItemsRef.current[0] : {}} onShowMedia={onShowMedia} setDoLoad={setDoLoad} fromPlanning={true} source={'planning'} onScheduleRefreshWithSocket={onScheduleRefreshWithSocket} onScheduleRefresh={planningLoading} />
          </TabPanel>
          <TabPanel value="4" style={{ height: "100%", padding: 0 }} >
            <MediaEpisodeHistory selectedData={plannerSelectedItemsRef.current.length > 0 ? plannerSelectedItemsRef.current[0].mediaEpisode : {}} isPopup={false} />
          </TabPanel>
          {!disableLiveEventSection && <TabPanel value="5" style={{ height: "100%", padding: 0 }} >
            <PlanningLiveEventsTab ref={liveEventRef} channels={filterChannelRef.current} MediaLibraryCollectionGridRowRender={MediaLibraryCollectionGridRowRender} planningLoading={planningLoading} showLoading={false} payload={payload} />
          </TabPanel>}
          <TabPanel value="6" style={{ height: "100%", padding: 0 }} >
            <PlanningContractMediaLibraryCollection
              channels={filterChannelRef.current}
              MediaLibraryCollectionGridRowRender={MediaLibraryCollectionGridRowRender}
              planningLoading={planningLoading}
              payload={payload}
              custom_columns={contractMediaEpisodeColumns}
            />
          </TabPanel>
        </TabContext>
      </Splitter>

      <PlaningFooter
        handleChannelFilterDialog={handleChannelFilterDialog}
        statusMsg={statusMsg}
        selectedPlanningItemCount={plannerSelectedItemsRef.current.length}
        plannerCopiedItemsCount={plannerCopiedItems.length}
        onOpenPlanningPreference={onOpenPlanningPreference}
        planningLoading={planningLoading}
        showExcelPopup={showExcelPopup}
        showMissingSegmentMAMReportPopup={showMissingSegmentMAMReportPopup}
        onShowCopySchedulePopup={onShowCopySchedulePopup}
        onDurationTypeChange={onDurationTypeChange}
        durationType={durationType}
        startType={startType}
        onStartTypeChange={onStartTypeChange}
        date={selectedDate}
        onCheckList={onCheckList}
        onAutoPlanning={onShowAutoPlaningPopup}
        currentPlanningView={currentPlanningView}
        setCurrentPlanningView={setCurrentPlanningView}
        dummyPlanningPopup={dummyPlanningPopup}
        onShowCopySlotPopup={onShowCopySlotPopup}
      ></PlaningFooter>
      {/* all dialogs here */}

      <PlanningFilterDialog
        open={showFilter}
        onClose={handleChannelFilterDialog}
        onConfirm={handleFilterPopupConfirm}
        ChannelList={ChannelList}
        lang={lang}
        filterChannels={planningChannelSelectorFilteredChannels}
        setFilterChannels={setPlanningChannelSelectorFilteredChannels}
        date={date}
        onDateChange={handleChangeDate}
        hideCloseIcon={!isFirst}
      />

      {openPlanningPreference && (<PlanningPreference closeForm={onClickPlanningPreference} entityName={ENTITYNAME.UserPreference} updatePlanningPreferenceStyle={updatePlanningPreferenceStyle} />)}

      {showRecursivePopup && (<Recursive
        selectedAppointment={plannerSelectedItemsRef.current[0]}
        closeForm={() => setShowRecursivePopup(false)}
        onGenerateRecursion={onGenerateRecursion} />)}

      {showPlanningDistributionTemplate && <PlanningDistribution selectedData={plannerSelectedItemsRef.current[0]} closeForm={() => setShowPlanningDistributionTemplate(false)} setDistributionTemplateData={setDistributionTemplateData} />}

      {showHistory && (<MediaEpisodeHistory selectedData={plannerSelectedItemsRef.current[0].mediaEpisode} currentDataItem={plannerSelectedItemsRef.current[0]} closeForm={closeFormHistory} />)}

      {showExhibitions && <BossDialog
        title={'Exhibitions'}
        onClose={() => setShowExhibitions(false)}
        width={"50%"}
        height={"62%"}
      >
        <Grid data={programScheduleExhibitionData} style={{ height: "50vh", marginTop: "04px", overflow: "hidden" }}>
          <GridNoRecords>
            {exhibitionStatus}
          </GridNoRecords>
          <GridColumn field="Channel.FullChannelName" title={lang.channel_column} width={188} />
          <GridColumn field="SlotDateTime" title={lang.slot_date_column} cell={DateOnlyCell} width={180} />
          <GridColumn field="SlotDateTime" title={lang.slot_time_column} cell={TimeCell} width={180} />
          <GridColumn field="ExhibitionNumber" title={lang.exhibition_no_column} width={180} />
          <GridColumn field="RepeatNumber" title={lang.repeat_no_column} width={180} />
        </Grid>
      </BossDialog>}

      {showInsertProgramGroup && (<CollectionSelection
        title={lang.select_program_group_label}
        entityname={ENTITYNAME.MediaEpisodeGroup}
        wherestatement={['MediaCategory.isLong', '=', true]}
        setDataList={addProgramGroup}
        mode={"single"}
        closeForm={closeInsertProgramGroup}
      />)}

      {showCopySchedulePopup &&
        <CopySchedule planningLoading={planningLoading} closeForm={onCloseCopySchedulePopup} plannerPayload={{ date: date, channels: filterChannels }} />}

      {showCopySlotPopup &&
        <CopySlotsForm planningLoading={planningLoading} closeForm={onCloseCopySlotPopup} plannerPayload={{ date: date, channels: filterChannels }} />}

      {showExportExcelPopup && <PlannerExportExcelForm
        closeExcelPopup={() => setShowExportExcelPopup(false)}
        ChannelList={ChannelList}
        slotDuration={planningRef.current.getSelectedSlotDuration()}
        exportChannel={exportChannel}
        setExportChannel={setExportChannel}
      />}

      {showCtrlAPopup && <BossDialog
        title={'Options'}
        width={"350px"}
        onClose={onClickCtrlACancelAction}
      >
        <div>
          <div className="mb-3">
            <Checkbox style={{ borderColor: "black" }} name="" value={selectedCtrlAOption == 0} onChange={() => onClickCtrlAOptions(0)} />
            <span style={{ fontSize: "16px", paddingLeft: "5px" }}>Select all items in planning grid</span>
          </div>
          <div className="mb-3" >
            <Checkbox style={{ borderColor: "black" }} name="" value={selectedCtrlAOption == 1} onChange={() => onClickCtrlAOptions(1)} />
            <span style={{ fontSize: "16px", paddingLeft: "5px" }}>Select all items for selected date</span>
          </div>
          <div className="mb-3" >
            <Checkbox style={{ borderColor: "black" }} name="" value={selectedCtrlAOption == 2} onChange={() => onClickCtrlAOptions(2)} />
            <span style={{ fontSize: "16px", paddingLeft: "5px" }}>Select all similar episodes</span>
          </div>
          <div>
            <Checkbox style={{ borderColor: "black" }} name="" value={selectedCtrlAOption == 3} onChange={() => onClickCtrlAOptions(3)} />
            <span style={{ fontSize: "16px", paddingLeft: "5px" }}>Select all episodes of selected series</span>
          </div>
        </div>
        <div className="mt-3" >
          <ActionButton style={{ marginLeft: "0", marginRight: "10px" }} title={'Ok'} name={'Ok'} onClick={onClickCtrlAOkayAction} />
          <ActionButton btnColor={'danger'} title={lang.cancel_button_text} name={lang.cancel_button_text} onClick={onClickCtrlACancelAction} />
        </div>

      </BossDialog>}


      {showDeletePopup && <BossDialog
        title={'Delete Linked Event'}
        width={"580px"}
        onClose={showDeleteMenu}
      >
        <Box sx={{ minWidth: 0 }}>
          <Box sx={{ display: 'grid', gap: 1.25 }}>
            {[
              {
                option: PLANNING_DELETE_OPTION.DELETE_SELECTED,
                label: lang.delete_selected_label,
                message: "Selected item will be deleted and the slot will remain empty.",
                disabled: false,
              },
              {
                option: PLANNING_DELETE_OPTION.PUSH_FORWARD,
                label: lang.delete_slot_and_push_forward_in_the_strand_label,
                message: "This slot will be completely removed and episodes will move to a forward slot.",
                disabled: plannerSelectedItemsRef.current.length > 1,
              },
              {
                option: PLANNING_DELETE_OPTION.PULL_BACKWARD_AND_DELETE_CURRENT,
                label: lang.delete_slot_and_pull_backward_in_the_strand_label,
                message: "This slot will be retained but episodes will be moved to an earlier slot and the selected episode will be removed.",
                disabled: plannerSelectedItemsRef.current.length > 1,
              },
              {
                option: PLANNING_DELETE_OPTION.DELETE_ALL_FORWARD_IN_STRAND,
                label: lang.delete_all_the_events_forward_in_the_strand_label,
                message: "This will remove all the slots from selected event forward in the strand.",
                disabled: plannerSelectedItemsRef.current.length > 1,
              },
              {
                option: PLANNING_DELETE_OPTION.DELETE_FUTURE_EVENT,
                label: lang.delete_episode_in_future_from_selected_slot_forward_label,
                message: "This episode will be completely removed from the planning from selected event forward.",
                disabled: plannerSelectedItemsRef.current.length > 1,
              },
            ].map((item) => (
              <Box
                key={item.option}
                onClick={() => !item.disabled && onClickDeleteOptions(item.option)}
                sx={{
                  display: 'grid',
                  gridTemplateColumns: 'auto 1fr',
                  gap: 1,
                  alignItems: 'flex-start',
                  px: 1.5,
                  py: 1,
                  borderRadius: '10px',
                  border: '1px solid #e4e7eb',
                  bgcolor: item.disabled ? '#f7f8fa' : '#ffffff',
                  cursor: item.disabled ? 'not-allowed' : 'pointer',
                  '&:hover': {
                    bgcolor: item.disabled ? '#f7f8fa' : '#f8fafd',
                  },
                }}
              >
                <Checkbox
                  disabled={item.disabled}
                  style={{ borderColor: 'black', marginTop: 2 }}
                  name=""
                  value={selectedDeleteOption == item.option}
                  onChange={() => onClickDeleteOptions(item.option)}
                />
                <Box sx={{ minWidth: 0 }}>
                  <Typography sx={{ fontSize: 14, fontWeight: 600, color: item.disabled ? '#7d8994' : '#202a35' }}>
                    {item.label}
                  </Typography>
                  <Typography sx={{ mt: 0.5, fontSize: 13, color: item.disabled ? '#7d8994' : '#56606b', lineHeight: 1.5 }}>
                    {item.message}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>

          {plannerSelectedItemsRef.current.length > 1 && (
            <Typography sx={{ mt: 1.5, fontSize: 12, color: '#6c757d' }}>
              {lang.to_enable_other_options_select_only_one_item_label}
            </Typography>
          )}

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 1,
              mt: 2.5,
              pt: 1.25,
              borderTop: '1px solid #e8ebef',
            }}
          >
            <Button
              onClick={showDeleteMenu}
              variant="outlined"
              size="small"
              sx={{
                textTransform: 'none',
                borderRadius: '4px',
                borderColor: '#ccc',
                color: '#444',
                minWidth: 88,
                px: 2,
                '&:hover': { bgcolor: '#f5f5f5', borderColor: '#999' },
              }}
            >
              {lang.cancel_button_text}
            </Button>
            <Button
              onClick={onClickDeleteOkayAction}
              variant="contained"
              size="small"
              sx={{
                textTransform: 'none',
                borderRadius: '4px',
                bgcolor: '#3A3633',
                color: '#fff',
                minWidth: 88,
                px: 2,
                '&:hover': { bgcolor: '#2a2623' },
              }}
            >
              OK
            </Button>
          </Box>
        </Box>
      </BossDialog>}

      {showLoopPopup && <BossDialog
        style={{
          position: "absolute",
          top: "100px"
        }}
        title={'Loop'}
        width={"600px"}
        onClose={closeLoopPopup}

      >
        <EditPageHeader onSubmit={onLoopConfirm} onCancel={closeLoopPopup} showTitle={false} />
        <br />
        <div className="row">
          <div className="col-6">
            <label>From Slot Date</label>
            <DatePicker
              format={
                {
                  skeleton: "yMMMd",
                }
              }
              disabled={true}
              value={loopPopupData.startDate}
            />
          </div>
          <div className="col-6">
            <label>From Slot Time</label>
            <TimePickerWithFormat disabled={true} value={loopPopupData.startDateTime} />
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-6">
            <label>End Slot Date</label>
            <DatePicker
              value={loopPopupData.endDate}
              format={
                {
                  skeleton: "yMMMd",
                }
              }
              onChange={(e) => {
                setLoopPopupData({ ...loopPopupData, endDate: e.target.value })
              }}
            />
          </div>
          <div className="col-6">
            <label>End Slot Time</label>
            <TimePickerWithFormat value={loopPopupData.endDateTime}
              onChange={(e) => {
                setLoopPopupData({ ...loopPopupData, endDateTime: e.target.value })
              }} />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-6">
            <label>{lang.channel_label}:</label>
            <MultiSelect
              data={ChannelList}
              textField="FullChannelName"
              dataItemKey="_id"
              value={loopPopupData.channels}
              onChange={(e) => {
                if (e.target.value.length == 0) {
                  setLoopPopupData({ ...loopPopupData, channels: [loopPopupData.data.Channel] })
                } else {
                  setLoopPopupData({ ...loopPopupData, channels: e.target.value })
                }
              }}
            />
          </div>
        </div>
      </BossDialog>}

      {showAutoPlanningPopup && <BossDialog
        title={'Auto Planning Plotting'}
        width={"600px"}
        onClose={() => setShowAutoPlanningPopup(false)}

      >
        <EditPageHeader saveButtonTitle={"Generate"} onSubmit={getAutoPlanningTentativeData} onCancel={() => setShowAutoPlanningPopup(false)} showTitle={false} />
        <br />
        <div className='row'>
          <div className="col-4">
            <label>{lang.channel_label}:</label>
            <DropDownList
              data={ChannelList}
              textField="name"
              dataItemKey="_id"
              value={autoPlaningData.Channel}
              onChange={(e) => { startTransition(() => setAutoPlaningData({ ...autoPlaningData, Channel: e.target.value })) }}
            />
          </div>
          <div className="col-4">
            <label htmlFor="">{lang.from_label}</label>
            <input className="form-control form-control-sm" type={'date'} name={"From"} placeholder={""} label={lang.from_label} onChange={(e) => { startTransition(() => setAutoPlaningData({ ...autoPlaningData, FromDate: e.target.value })) }} value={autoPlaningData.FromDate} style={{ width: '100%', backgroundColor: 'white', border: '1px solid lightgrey', borderRadius: '5px', paddingLeft: '5px', height: '30px' }} />
          </div>
          <div className="col-4">
            <label htmlFor="">{lang.to_label}</label>
            <input className="form-control form-control-sm" type={'date'} name={"To"} placeholder={""} label={lang.to_label} onChange={(e) => { startTransition(() => setAutoPlaningData({ ...autoPlaningData, ToDate: e.target.value })) }} value={autoPlaningData.ToDate} style={{ width: '100%', backgroundColor: 'white', border: '1px solid lightgrey', borderRadius: '5px', paddingLeft: '5px', height: '30px' }} />
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-12" style={{ textAlign: "left" }}>
            <div className="form-group">
              <div style={{ height: "35px", backgroundColor: "#cce5ed" }} className="form-control form-control-sm" name="DisplayName">{isLoading ? "Preparing tentative schedule, wait for magic to happen..." : ""}</div>
            </div>
          </div>
        </div>
      </BossDialog>}

      {showAutoPlanningTentativePopup && <BossDialog title={"Tentative Schedule"} onClose={() => { setShowAutoPlanningTentativePopup(false); setIsLoading(true); }} width={"50vw"}>
        <EditPageHeader saveButtonTitle={"Plot"} onSubmit={onAutoPlanningPlotting} onCancel={() => setShowAutoPlanningTentativePopup(false)} showTitle={false} />
        {isLoading && <Loader height="40vh" description={"Preparing tentative schedule, wait for magic to happen..."} bossAI={enableBossAI} />}
        {!isLoading && <Grid data={autoPlanningTentativeData} style={{ height: "400px" }} rowHeight={50} resizable={true}>
          <GridColumn field={'mediaEpisode.Title'} title={'Title'} width={'200px'} />
          <GridColumn field={'SlotDateTime'} title={'Date'} cell={DateOnlyCell} width={'120px'} />
          <GridColumn field={'SlotDateTime'} title={'Time'} cell={TimeCell} width={'120px'} />
          <GridColumn title={'Channel'} field={'Channel.FullChannelName'} width={'120px'} />
          <GridColumn field={'PlanningSlot.Description'} title={'Slot'} width={'120px'} />
          <GridColumn field={'mediaEpisode.MediaCategory.Description'} title={'Media Category'} width={'120px'} />
          <GridColumn field={'mediaEpisode.Duration'} title={'Duration'} cell={TimeCell} sortable={true} width={'120px'} />
          <GridColumn field={'mediaEpisode.Genres'} title={'Genres'} cell={ArrayCell} format={'Description'} width={'200px'} />
        </Grid>}
      </BossDialog>}

      {showRecursivePlanPopup && <RecursivePlanPopup
        onClose={() => setShowRecursivePlanPopup(false)}
        RecursionParentProgramSchedule_id={plannerSelectedItemsRef.current[0]?.RecursionParentProgramSchedule_id} />}
      <ProgressBarPopup ModuleID={MODULE.PLANNING} />
      {showProgressBar.progressBarPopup && <div id='myProgressBar'>
        <div className='myProgressBarBox' style={enableBossAI ? { paddingTop: '30px', height: "200px" } : {}}>

          {enableBossAI && <img src={bossAIPng} alt="Boss AI" className={progressData.progress == 100 ? "" : 'pop-effect'} style={{ width: '50px', height: '50px' }} />}

          <ProgressBar
            label={(props) => { return <strong>{props.value}%</strong> }}
            labelPlacement='center'
            progressStyle={{ backgroundColor: enableBossAI ? "#6719b3" : "green" }}
            value={progressData.progress}
            style={{ width: "360px" }}
          />
          <div className='message' style={enableBossAI ? { top: "145px" } : {}}>
            <p>{progressData.message}</p>
          </div>
          {showProgressBar.okButton && <button
            onClick={() => { setShowProgressBar({ ...showProgressBar, progressBarPopup: false }); }}
            style={{ width: "50px", backgroundColor: enableBossAI ? "#3D365C" : "green" }}
            className='k-button k-button-md k-rounded-md k-button-solid k-button-solid-base text-white' >
            OK
          </button>
          }
        </div>
      </div>}
      {showDealPopup.show && <MediaDealRightsPopup mediaDealRight_id={showDealPopup.mediaDealRight_id} onClose={() => { setShowDealPopup({ show: false, media_id: null }) }} />}
      {showExportMissingSegmentMAMReportPopup && <MissingSegmentMamReport item={publishData} onClose={() => setShowExportMissingSegmentMAMReportPopup(false)} />}
      {showDummyPlanningPopup &&
        <PlanningInsertDummyPopup
          selectedSlot={{ SlotDateTime: new Date(selectedDate) }}
          isPrimeTime={isPrimeTime}
          multiple={true}
          onClose={() => setShowDummyPlanningPopup(false)}
          channel={filterChannelRef.current}
          addPlanningItem={planningRef?.current?.addPlanningItem}
        />
      }
    </>
  );
};

export default PlannerWrapperNew;
